import { IdentityVerification, IdentityVerificationStatus } from '@/models'

export const getIsIdentityVerificationPending = (status?: IdentityVerification['status']) => {
    if (!status) return true

    return (
        status === IdentityVerificationStatus.Retry ||
        status === IdentityVerificationStatus.Requested ||
        status === IdentityVerificationStatus.Started
    )
}

export const getIsIdentityVerificationFinished = (status?: IdentityVerification['status']) => {
    if (!status) return false

    return status === IdentityVerificationStatus.Verified || status === IdentityVerificationStatus.Cancelled
}
